<template>
  <reference-layout class="function">
    <template #header>
      <reference-header :header-title="functionModel.id ? 'Редактирование функции' : 'Новая функция'">
        <template v-if="functionModel.id" #header-title-action>
          <div class="function__info">
            <svg-icon :name="'status-' + functionModel.status.code" v-b-popover.hover.blur.top="functionModel.status.title" class="function__status" />
            <div class="function__name">{{ functionModel.name }}</div>
          </div>
          
        </template>
        <template #header-actions>
          <div class="layout-header-action">
            <c-button
              v-if="functionModel.id"
              size="small"
              icon="comment"
              label="0 комментариев"
              :tooltip="{
                text: 'Комментарий',
                activeText: 'Комментарий',
              }"
            />
          </div>
          <div class="layout-header-action">
            <m-confirm ref="confirm" mode="danger" />
            
            <c-button
              v-if="functionModel.id"
              :icon="{ icon: 'trash', color: 'secondary' }"
              size="small"
              label="Удалить"
              @click="deleteFunction"
            />
          </div>
          <div class="layout-header-action">
            <c-button
              size="small"
              label="К списку функций"
              :icon="{
                icon: 'back',
              }"
              :responsive="true"
              @click="$router.push({ name: 'functions' })"
            />
          </div>
        </template>
      </reference-header>
    </template>

    <template #subheader>
      <div class="function__tabs">
        <c-tabs :items="tabs.items" with-routing />
      </div>
    </template>

    <template #list>
      <div class="function__content">
        <router-view
          ref="route"
        />
      </div>
    </template>
  </reference-layout>
</template>

<script>
import { mapState } from "vuex";
import ReferenceLayout from "@/layouts/reference-layout";
import ReferenceHeader from "@/components/reference-components/reference-header";
import Button1 from "@/components/controls/button";
import Button from "@/components/controls2/Button";
import Tabs from "@/components/tabs";
import SvgIcon from "@/components/svg-icon";
import Confirm from "@/components/modals/confirm-modal";

export default {
  name: "functions",
  components: {
    "c-button-1": Button1,
    "c-button": Button,
    "c-tabs": Tabs,
    "m-confirm": Confirm,
    ReferenceLayout,
    ReferenceHeader,
    SvgIcon,
  },
  async created() {
    const { query } = this.$route;

    if (query.id) await this.$store.dispatch("functions/getFunctionModel", query.id)
      .then(res => {
        // console.log('res', res)
        // if (res.message.indexOf('Функция не найдена') !== -1) {
        //   this.$router.replace({ name: "functions" });
        // }
      })
      .catch(res => {
        this.$router.replace({ name: "functions" });
      })
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapState({
      functionModel: (state) => state.functions.functionModel,
    }),
    tabs() {
      let query = {};

      if (this.functionModel.id) query.id = this.functionModel.id

      const items = [
        { label: "Информация", value: "function-information", query },
        { label: "Показатели", value: "function-indicators", disabled: this.functionModel.id ? false : true, query },
        { label: "Отладка", value: "function-debugging", disabled: this.functionModel.id ? false : true, query },
      ];

      return { items };
    },
  },
  methods: {
    deleteFunction() {
      this.$refs.confirm.open({
        title: "Удаление функции",
        text: `Функция <b>${this.functionModel.name}</b> будет удалена без возможности восстановления`,
        confirm: "Удалить",
        onConfirm: () => {
          this.$store.dispatch("functions/deleteFunction", this.functionModel.id).then(res => {
            this.$router.replace({ name: "functions" });
          });
        },
      });
    }
  },
  beforeDestroy() {
    this.$store.commit("functions/setFunctionModel", {});
    this.$store.commit("functions/setDefaultPerformers", []);
    this.$store.commit("functions/setCheckboxAll", true);
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.function {
  position: relative;

  &__tabs {
    width: 100%;
  }

  &__info {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-top: 5px;
    // margin-bottom: 30px;
  }

  &__status {
    margin-right: 10px;
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }

  /deep/ {
    .layout-title {
      flex-direction: column;
      align-items: flex-start;
    }

    .layout-header {
      height: auto;
      margin-bottom: 0;
      padding-bottom: 30px;
    }

    @media (min-width: 700px) {
      .layout {
        padding: 24px 30px 170px 30px;
      }
    }

    .function {
      // max-height: 92vh;
      // padding-left: 5px;

      &__actions {
        display: flex;
        align-items: center;
        position: relative;
        
        &--fixed {
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 10px 25px;
          background-color: #FFFFFF;
          width: 110%;
          box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
          z-index: 11111;

          @include vp-767 {
            position: fixed;
            bottom: 0;
            left: 0;
            
          }
        }
      }

      &__action {
        &:first-child {
          margin-right: 10px;
        }
      }

      &-reset {
        margin-right: 10px;
      }

      @media screen and (max-width: 700px) {
        height: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 24px;

        &__actions {
          margin-top: auto;
          margin-left: -20px;
          margin-right: -20px;

          .c-button {
            border-radius: 0 !important;
            width: 50%;
            margin: 0 !important;
          }
        }
      }
    }
  }
}

</style>

